import { render, staticRenderFns } from "./sub-title.vue?vue&type=template&id=702fa038&scoped=true&"
import script from "./sub-title.vue?vue&type=script&lang=js&"
export * from "./sub-title.vue?vue&type=script&lang=js&"
import style0 from "./sub-title.vue?vue&type=style&index=0&id=702fa038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702fa038",
  null
  
)

export default component.exports